<template>
  <div class="container-fluid">
    <v-form v-model="valid">
      <h2>Password reset</h2>
      <v-row>
        <v-text-field
          v-model="credentials.email"
          id="email"
          required
          :rules="emailRules"
          label="Enter e-mail"
        ></v-text-field>
      </v-row>

      <v-row class="form-actions-container">
        <v-btn v-if="!loading" :disabled="!valid" @click="emailReset"
          >Reset password</v-btn
        >
        <SmallLoaderLight class="form-loader" v-if="loading" />
      </v-row>
          <v-row class="form-success-response" v-if="response">
      <p>Check your e-mail</p>
    </v-row>
    </v-form>
    <v-row class="form-error-container">
      <transition name="fade">
        <template v-if="errors">
          <Alert
            :key="error.field"
            v-for="error in errors"
            :message="error.error"
            type="error"
            :handle-click="cleanError"
          />
        </template>
      </transition>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { validEmail } from "@/utils/texts.util";
import SmallLoaderLight from "@/components/atoms/SmallLoaderLight";
import Alert from "@/components/atoms/Alert";

export default {
  components: {
    SmallLoaderLight,
    Alert,
  },
  data() {
    return {
      valid: false,
      loading: false,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      credentials: {
        success: true,
        email: null,
        response: "",
      },
    };
  },
  methods: {
    async emailReset() {
      this.$store.commit("RESET_SIGNUP_ERROR");
      this.loading = true;
      this.response = await this.$store.dispatch(
        "emailReset",
        this.credentials
      );

      this.loading = false;
    },
    cleanError() {
      this.$store.commit("RESET_SIGNUP_ERROR");
    },
  },
  computed: mapState({
    errors: (state) => state.errors.signup,
    validCredentials: function () {
      return this.credentials.email && validEmail(this.credentials.email);
    },
  }),
  mounted() {
    this.$store.commit("RESET_SIGNUP_ERROR");
  },
};
</script>


